/**
 * The RSS Aggregator (Smarter RSS)
 *
 * Exposes three web-accessible resources — app/views/subscribe/subscribe.html plus the
 * loading-bar.gif and 16x16.png images under app/images — to every origin with no
 * `use_dynamic_url`. All sit at a fixed, vendor-pathed URL, so they are fetchable from
 * any page; the images load through `probeImage` without a CORS grant.
 *
 * Manifest verified against version 5.8.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'ffhafkagcdhnhamiaecajogjcfgienom';

export const theRssAggregator: ExtensionDefinition = {
  id: ID,
  name: 'The RSS Aggregator',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 10_000,
  notes:
    'Three static WAR under /app exposed to every origin with no dynamic URL. The ' +
    'loading-bar image loads without a CORS grant; subscribe.html corroborates.',
  signals: [
    {
      id: 'war-loading-bar-gif',
      kind: 'web-accessible-resource',
      description:
        'Load app/images/loading-bar.gif via <img> — a bundled image exposed to every ' +
        'origin; needs no CORS grant, so it survives a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'app/images/loading-bar.gif'),
    },
    {
      id: 'war-16x16-png',
      kind: 'web-accessible-resource',
      description: 'Load app/images/16x16.png via <img> — a second image, corroborating.',
      weight: 0.5,
      run: () => probeImage(ID, 'app/images/16x16.png'),
    },
    {
      id: 'war-subscribe-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch app/views/subscribe/subscribe.html — the subscribe view, an independent path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'app/views/subscribe/subscribe.html'),
    },
  ],
};
